import { ToWords } from 'to-words';

class CurrencyWordsFormatter {
    static getCurrencyConfig(currencyCode) {
        const currencyConfigs = {
            // Indian Subcontinent
            'INR': {
                locale: 'en-IN',
                currencyName: 'Rupee',
                currencyNamePlural: 'Rupees',
                fractionalName: 'Paisa',
                fractionalNamePlural: 'Paise',
                format: 'indian'  // Indian numbering system (lakhs, crores)
            },
            // US and similar
            'USD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'CAD': {
                locale: 'en-CA',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'AUD': {
                locale: 'en-AU',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            // European
            'EUR': {
                locale: 'en-US',  // Generic English for Euro
                currencyName: 'Euro',
                currencyNamePlural: 'Euro',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'CHF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Rappen',
                fractionalNamePlural: 'Rappen',
                format: 'standard'
            },
            'SEK': {
                locale: 'en-US',
                currencyName: 'Krona',
                currencyNamePlural: 'Kronor',
                fractionalName: 'Öre',
                fractionalNamePlural: 'Öre',
                format: 'standard'
            },
            'NOK': {
                locale: 'en-US',
                currencyName: 'Krone',
                currencyNamePlural: 'Kroner',
                fractionalName: 'Øre',
                fractionalNamePlural: 'Øre',
                format: 'standard'
            },
            'DKK': {
                locale: 'en-US',
                currencyName: 'Krone',
                currencyNamePlural: 'Kroner',
                fractionalName: 'Øre',
                fractionalNamePlural: 'Øre',
                format: 'standard'
            },
            'PLN': {
                locale: 'en-US',
                currencyName: 'Zloty',
                currencyNamePlural: 'Zlotys',
                fractionalName: 'Grosz',
                fractionalNamePlural: 'Grosze',
                format: 'standard'
            },
            'RUB': {
                locale: 'en-US',
                currencyName: 'Ruble',
                currencyNamePlural: 'Rubles',
                fractionalName: 'Kopek',
                fractionalNamePlural: 'Kopeks',
                format: 'standard'
            },
            'TRY': {
                locale: 'en-US',
                currencyName: 'Lira',
                currencyNamePlural: 'Lira',
                fractionalName: 'Kurus',
                fractionalNamePlural: 'Kurus',
                format: 'standard'
            },
            'HUF': {
                locale: 'en-US',
                currencyName: 'Forint',
                currencyNamePlural: 'Forint',
                fractionalName: 'Filler',
                fractionalNamePlural: 'Filler',
                format: 'standard',
                noCents: true
            },
            'CZK': {
                locale: 'en-US',
                currencyName: 'Koruna',
                currencyNamePlural: 'Koruny',
                fractionalName: 'Heller',
                fractionalNamePlural: 'Hellers',
                format: 'standard'
            },
            'RON': {
                locale: 'en-US',
                currencyName: 'Leu',
                currencyNamePlural: 'Lei',
                fractionalName: 'Ban',
                fractionalNamePlural: 'Bani',
                format: 'standard'
            },
            // British
            'GBP': {
                locale: 'en-GB',
                currencyName: 'Pound',
                currencyNamePlural: 'Pounds',
                fractionalName: 'Penny',
                fractionalNamePlural: 'Pence',
                format: 'standard'
            },
            // Middle Eastern & African
            'AED': {
                locale: 'en-US',
                currencyName: 'Dirham',
                currencyNamePlural: 'Dirhams',
                fractionalName: 'Fils',
                fractionalNamePlural: 'Fils',
                format: 'standard',
                decimalPlaces: 2
            },
            'SAR': {
                locale: 'en-US',
                currencyName: 'Riyal',
                currencyNamePlural: 'Riyals',
                fractionalName: 'Halala',
                fractionalNamePlural: 'Halalas',
                format: 'standard',
                decimalPlaces: 2
            },
            'EGP': {
                locale: 'en-US',
                currencyName: 'Pound',
                currencyNamePlural: 'Pounds',
                fractionalName: 'Piastre',
                fractionalNamePlural: 'Piastres',
                format: 'standard',
                decimalPlaces: 2
            },
            'QAR': {
                locale: 'en-US',
                currencyName: 'Riyal',
                currencyNamePlural: 'Riyals',
                fractionalName: 'Dirham',
                fractionalNamePlural: 'Dirhams',
                format: 'standard'
            },
            'KWD': {
                locale: 'en-US',
                currencyName: 'Dinar',
                currencyNamePlural: 'Dinars',
                fractionalName: 'Fils',
                fractionalNamePlural: 'Fils',
                format: 'standard',
                decimalPlaces: 3  // Kuwaiti Dinar has 3 decimal places
            },
            'IQD': {
                locale: 'en-US',
                currencyName: 'Dinar',
                currencyNamePlural: 'Dinars',
                fractionalName: 'Fils',
                fractionalNamePlural: 'Fils',
                format: 'standard',
                decimalPlaces: 3
            },
            'BHD': {
                locale: 'en-US',
                currencyName: 'Dinar',
                currencyNamePlural: 'Dinars',
                fractionalName: 'Fils',
                fractionalNamePlural: 'Fils',
                format: 'standard',
                decimalPlaces: 3
            },
            'OMR': {
                locale: 'en-US',
                currencyName: 'Rial',
                currencyNamePlural: 'Riyals',
                fractionalName: 'Baisa',
                fractionalNamePlural: 'Baisa',
                format: 'standard',
                decimalPlaces: 3
            },
            'JOD': {
                locale: 'en-US',
                currencyName: 'Dinar',
                currencyNamePlural: 'Dinars',
                fractionalName: 'Fils',
                fractionalNamePlural: 'Fils',
                format: 'standard',
                decimalPlaces: 3
            },
            'IRR': {
                locale: 'en-US',
                currencyName: 'Rial',
                currencyNamePlural: 'Rials',
                fractionalName: 'Dinar',
                fractionalNamePlural: 'Dinars',
                format: 'standard',
                decimalPlaces: 2,
                noCents: true // Often rounded to whole Rials in practice
            },
            'ILS': {
                locale: 'en-US',
                currencyName: 'Shekel',
                currencyNamePlural: 'Shekels',
                fractionalName: 'Agora',
                fractionalNamePlural: 'Agorot',
                format: 'standard'
            },
            'ZAR': {
                locale: 'en-ZA',
                currencyName: 'Rand',
                currencyNamePlural: 'Rand',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'KES': {
                locale: 'en-US',
                currencyName: 'Shilling',
                currencyNamePlural: 'Shillings',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'NGN': {
                locale: 'en-US',
                currencyName: 'Naira',
                currencyNamePlural: 'Naira',
                fractionalName: 'Kobo',
                fractionalNamePlural: 'Kobo',
                format: 'standard'
            },
            'GHS': {
                locale: 'en-US',
                currencyName: 'Cedi',
                currencyNamePlural: 'Cedis',
                fractionalName: 'Pesewa',
                fractionalNamePlural: 'Pesewas',
                format: 'standard'
            },
            'MAD': {
                locale: 'en-US',
                currencyName: 'Dirham',
                currencyNamePlural: 'Dirhams',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard'
            },
            'DZD': {
                locale: 'en-US',
                currencyName: 'Dinar',
                currencyNamePlural: 'Dinars',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard'
            },
            'TND': {
                locale: 'en-US',
                currencyName: 'Dinar',
                currencyNamePlural: 'Dinars',
                fractionalName: 'Millime',
                fractionalNamePlural: 'Millimes',
                format: 'standard',
                decimalPlaces: 3
            },
            'UGX': {
                locale: 'en-US',
                currencyName: 'Shilling',
                currencyNamePlural: 'Shillings',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard',
                noCents: true
            },
            'TZS': {
                locale: 'en-US',
                currencyName: 'Shilling',
                currencyNamePlural: 'Shillings',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard',
                noCents: true
            },
            // Asian & Pacific
            'CNY': {
                locale: 'en-US',
                currencyName: 'Yuan',
                currencyNamePlural: 'Yuan',
                fractionalName: 'Fen',
                fractionalNamePlural: 'Fen',
                format: 'standard'
            },
            'HKD': {
                locale: 'en-HK',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'TWD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'SGD': {
                locale: 'en-SG',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'NZD': {
                locale: 'en-NZ',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'THB': {
                locale: 'en-US',
                currencyName: 'Baht',
                currencyNamePlural: 'Baht',
                fractionalName: 'Satang',
                fractionalNamePlural: 'Satang',
                format: 'standard'
            },
            'MYR': {
                locale: 'en-US',
                currencyName: 'Ringgit',
                currencyNamePlural: 'Ringgit',
                fractionalName: 'Sen',
                fractionalNamePlural: 'Sen',
                format: 'standard'
            },
            'IDR': {
                locale: 'en-US',
                currencyName: 'Rupiah',
                currencyNamePlural: 'Rupiah',
                fractionalName: 'Sen',
                fractionalNamePlural: 'Sen',
                format: 'standard',
                noCents: true
            },
            'PHP': {
                locale: 'en-US',
                currencyName: 'Peso',
                currencyNamePlural: 'Pesos',
                fractionalName: 'Sentimo',
                fractionalNamePlural: 'Sentimos',
                format: 'standard'
            },
            'VND': {
                locale: 'en-US',
                currencyName: 'Dong',
                currencyNamePlural: 'Dong',
                fractionalName: 'Xu',
                fractionalNamePlural: 'Xu',
                format: 'standard',
                noCents: true
            },
            'PKR': {
                locale: 'en-US',
                currencyName: 'Rupee',
                currencyNamePlural: 'Rupees',
                fractionalName: 'Paisa',
                fractionalNamePlural: 'Paise',
                format: 'standard'
            },
            'LKR': {
                locale: 'en-US',
                currencyName: 'Rupee',
                currencyNamePlural: 'Rupees',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'BDT': {
                locale: 'en-US',
                currencyName: 'Taka',
                currencyNamePlural: 'Taka',
                fractionalName: 'Poisha',
                fractionalNamePlural: 'Poisha',
                format: 'standard'
            },
            'NPR': {
                locale: 'en-US',
                currencyName: 'Rupee',
                currencyNamePlural: 'Rupees',
                fractionalName: 'Paisa',
                fractionalNamePlural: 'Paise',
                format: 'standard'
            },
            'KZT': {
                locale: 'en-US',
                currencyName: 'Tenge',
                currencyNamePlural: 'Tenge',
                fractionalName: 'Tiyn',
                fractionalNamePlural: 'Tiyn',
                format: 'standard'
            },
            'JPY': {
                locale: 'en-US',
                currencyName: 'Yen',
                currencyNamePlural: 'Yen',
                fractionalName: 'Sen',  // Rarely used, 1/100 of yen
                fractionalNamePlural: 'Sen',
                format: 'standard',
                noCents: true  // Yen typically doesn't use decimal places
            },
            'KRW': {
                locale: 'en-US',
                currencyName: 'Won',
                currencyNamePlural: 'Won',
                fractionalName: 'Jeon',  // Not used in practice
                fractionalNamePlural: 'Jeon',
                format: 'standard',
                noCents: true
            },
            // Latin America
            'BRL': {
                locale: 'en-US',
                currencyName: 'Real',
                currencyNamePlural: 'Reais',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'MXN': {
                locale: 'en-US',
                currencyName: 'Peso',
                currencyNamePlural: 'Pesos',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'ARS': {
                locale: 'en-US',
                currencyName: 'Peso',
                currencyNamePlural: 'Pesos',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'CLP': {
                locale: 'en-US',
                currencyName: 'Peso',
                currencyNamePlural: 'Pesos',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard',
                noCents: true
            },
            'COP': {
                locale: 'en-US',
                currencyName: 'Peso',
                currencyNamePlural: 'Pesos',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard',
                noCents: true
            },
            'PEN': {
                locale: 'en-US',
                currencyName: 'Sol',
                currencyNamePlural: 'Soles',
                fractionalName: 'Centimo',
                fractionalNamePlural: 'Centimos',
                format: 'standard'
            },
            'UYU': {
                locale: 'en-US',
                currencyName: 'Peso',
                currencyNamePlural: 'Pesos',
                fractionalName: 'Centesimo',
                fractionalNamePlural: 'Centesimos',
                format: 'standard'
            },
            'AFN': {
                locale: 'en-US',
                currencyName: 'Afghani',
                currencyNamePlural: 'Afghanis',
                fractionalName: 'Pul',
                fractionalNamePlural: 'Pul',
                format: 'standard'
            },
            'ALL': {
                locale: 'en-US',
                currencyName: 'Lek',
                currencyNamePlural: 'Lekë',
                fractionalName: 'Qindarkë',
                fractionalNamePlural: 'Qindarkë',
                format: 'standard'
            },
            'AOA': {
                locale: 'en-US',
                currencyName: 'Kwanza',
                currencyNamePlural: 'Kwanzas',
                fractionalName: 'Centimo',
                fractionalNamePlural: 'Centimos',
                format: 'standard'
            },
            'AMD': {
                locale: 'en-US',
                currencyName: 'Dram',
                currencyNamePlural: 'Drams',
                fractionalName: 'Luma',
                fractionalNamePlural: 'Luma',
                format: 'standard'
            },
            'AWG': {
                locale: 'en-US',
                currencyName: 'Florin',
                currencyNamePlural: 'Florin',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'AZN': {
                locale: 'en-US',
                currencyName: 'Manat',
                currencyNamePlural: 'Manat',
                fractionalName: 'Qapik',
                fractionalNamePlural: 'Qapik',
                format: 'standard'
            },
            'BSD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'BBD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'BYN': {
                locale: 'en-US',
                currencyName: 'Ruble',
                currencyNamePlural: 'Rubles',
                fractionalName: 'Kopek',
                fractionalNamePlural: 'Kopeks',
                format: 'standard'
            },
            'BZD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'XOF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard',
                noCents: true
            },
            'BMD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'BTN': {
                locale: 'en-US',
                currencyName: 'Ngultrum',
                currencyNamePlural: 'Ngultrums',
                fractionalName: 'Chetrum',
                fractionalNamePlural: 'Chetrums',
                format: 'standard'
            },
            'BOB': {
                locale: 'en-US',
                currencyName: 'Boliviano',
                currencyNamePlural: 'Bolivianos',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'BAM': {
                locale: 'en-US',
                currencyName: 'Mark',
                currencyNamePlural: 'Marks',
                fractionalName: 'Fening',
                fractionalNamePlural: 'Fenings',
                format: 'standard'
            },
            'BWP': {
                locale: 'en-US',
                currencyName: 'Pula',
                currencyNamePlural: 'Pula',
                fractionalName: 'Thebe',
                fractionalNamePlural: 'Thebe',
                format: 'standard'
            },
            'BND': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'BGN': {
                locale: 'en-US',
                currencyName: 'Lev',
                currencyNamePlural: 'Leva',
                fractionalName: 'Stotinka',
                fractionalNamePlural: 'Stotinki',
                format: 'standard'
            },
            'BIF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard',
                noCents: true
            },
            'KHR': {
                locale: 'en-US',
                currencyName: 'Riel',
                currencyNamePlural: 'Riels',
                fractionalName: 'Sen',
                fractionalNamePlural: 'Sen',
                format: 'standard'
            },
            'XAF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard',
                noCents: true
            },
            'CVE': {
                locale: 'en-US',
                currencyName: 'Escudo',
                currencyNamePlural: 'Escudos',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'KYD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'KMF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard',
                noCents: true
            },
            'CDF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard'
            },
            'CRC': {
                locale: 'en-US',
                currencyName: 'Colon',
                currencyNamePlural: 'Colones',
                fractionalName: 'Centimo',
                fractionalNamePlural: 'Centimos',
                format: 'standard'
            },
            'CUP': {
                locale: 'en-US',
                currencyName: 'Peso',
                currencyNamePlural: 'Pesos',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'DJF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard',
                noCents: true
            },
            'DOP': {
                locale: 'en-US',
                currencyName: 'Peso',
                currencyNamePlural: 'Pesos',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'ERN': {
                locale: 'en-US',
                currencyName: 'Nakfa',
                currencyNamePlural: 'Nakfa',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'ETB': {
                locale: 'en-US',
                currencyName: 'Birr',
                currencyNamePlural: 'Birr',
                fractionalName: 'Santim',
                fractionalNamePlural: 'Santim',
                format: 'standard'
            },
            'FJD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'GMD': {
                locale: 'en-US',
                currencyName: 'Dalasi',
                currencyNamePlural: 'Dalasis',
                fractionalName: 'Butut',
                fractionalNamePlural: 'Bututs',
                format: 'standard'
            },
            'GEL': {
                locale: 'en-US',
                currencyName: 'Lari',
                currencyNamePlural: 'Lari',
                fractionalName: 'Tetri',
                fractionalNamePlural: 'Tetri',
                format: 'standard'
            },
            'GTQ': {
                locale: 'en-US',
                currencyName: 'Quetzal',
                currencyNamePlural: 'Quetzales',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'GNF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard',
                noCents: true
            },
            'GYD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'HTG': {
                locale: 'en-US',
                currencyName: 'Gourde',
                currencyNamePlural: 'Gourdes',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard'
            },
            'HNL': {
                locale: 'en-US',
                currencyName: 'Lempira',
                currencyNamePlural: 'Lempiras',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'ISK': {
                locale: 'en-US',
                currencyName: 'Krona',
                currencyNamePlural: 'Kronur',
                fractionalName: 'Eyrir',
                fractionalNamePlural: 'Aurar',
                format: 'standard',
                noCents: true
            },
            'KPW': {
                locale: 'en-US',
                currencyName: 'Won',
                currencyNamePlural: 'Won',
                fractionalName: 'Chon',
                fractionalNamePlural: 'Chon',
                format: 'standard',
                noCents: true
            },
            'KGS': {
                locale: 'en-US',
                currencyName: 'Som',
                currencyNamePlural: 'Som',
                fractionalName: 'Tyiyn',
                fractionalNamePlural: 'Tyiyn',
                format: 'standard'
            },
            'LAK': {
                locale: 'en-US',
                currencyName: 'Kip',
                currencyNamePlural: 'Kips',
                fractionalName: 'Att',
                fractionalNamePlural: 'Att',
                format: 'standard',
                noCents: true
            },
            'LBP': {
                locale: 'en-US',
                currencyName: 'Pound',
                currencyNamePlural: 'Pounds',
                fractionalName: 'Piastre',
                fractionalNamePlural: 'Piastres',
                format: 'standard',
                noCents: true
            },
            'LSL': {
                locale: 'en-US',
                currencyName: 'Loti',
                currencyNamePlural: 'Maloti',
                fractionalName: 'Sente',
                fractionalNamePlural: 'Lisente',
                format: 'standard'
            },
            'LRD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'LYD': {
                locale: 'en-US',
                currencyName: 'Dinar',
                currencyNamePlural: 'Dinars',
                fractionalName: 'Dirham',
                fractionalNamePlural: 'Dirhams',
                format: 'standard',
                decimalPlaces: 3
            },
            'MOP': {
                locale: 'en-US',
                currencyName: 'Pataca',
                currencyNamePlural: 'Patacas',
                fractionalName: 'Avo',
                fractionalNamePlural: 'Avos',
                format: 'standard'
            },
            'MKD': {
                locale: 'en-US',
                currencyName: 'Denar',
                currencyNamePlural: 'Denars',
                fractionalName: 'Deni',
                fractionalNamePlural: 'Deni',
                format: 'standard'
            },
            'MGA': {
                locale: 'en-US',
                currencyName: 'Ariary',
                currencyNamePlural: 'Ariary',
                fractionalName: 'Iraimbilanja',
                fractionalNamePlural: 'Iraimbilanja',
                format: 'standard',
                noCents: true
            },
            'MWK': {
                locale: 'en-US',
                currencyName: 'Kwacha',
                currencyNamePlural: 'Kwacha',
                fractionalName: 'Tambala',
                fractionalNamePlural: 'Tambala',
                format: 'standard'
            },
            'MVR': {
                locale: 'en-US',
                currencyName: 'Rufiyaa',
                currencyNamePlural: 'Rufiyaa',
                fractionalName: 'Laari',
                fractionalNamePlural: 'Laari',
                format: 'standard'
            },
            'MRU': {
                locale: 'en-US',
                currencyName: 'Ouguiya',
                currencyNamePlural: 'Ouguiya',
                fractionalName: 'Khoum',
                fractionalNamePlural: 'Khoums',
                format: 'standard'
            },
            'MUR': {
                locale: 'en-US',
                currencyName: 'Rupee',
                currencyNamePlural: 'Rupees',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'MDL': {
                locale: 'en-US',
                currencyName: 'Leu',
                currencyNamePlural: 'Lei',
                fractionalName: 'Ban',
                fractionalNamePlural: 'Bani',
                format: 'standard'
            },
            'MNT': {
                locale: 'en-US',
                currencyName: 'Tugrik',
                currencyNamePlural: 'Tugriks',
                fractionalName: 'Mongo',
                fractionalNamePlural: 'Mongo',
                format: 'standard'
            },
            'MZN': {
                locale: 'en-US',
                currencyName: 'Metical',
                currencyNamePlural: 'Meticals',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'MMK': {
                locale: 'en-US',
                currencyName: 'Kyat',
                currencyNamePlural: 'Kyats',
                fractionalName: 'Pya',
                fractionalNamePlural: 'Pya',
                format: 'standard'
            },
            'NAD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'NIO': {
                locale: 'en-US',
                currencyName: 'Cordoba',
                currencyNamePlural: 'Cordobas',
                fractionalName: 'Centavo',
                fractionalNamePlural: 'Centavos',
                format: 'standard'
            },
            'PAB': {
                locale: 'en-US',
                currencyName: 'Balboa',
                currencyNamePlural: 'Balboas',
                fractionalName: 'Centesimo',
                fractionalNamePlural: 'Centesimos',
                format: 'standard'
            },
            'PGK': {
                locale: 'en-US',
                currencyName: 'Kina',
                currencyNamePlural: 'Kina',
                fractionalName: 'Toea',
                fractionalNamePlural: 'Toea',
                format: 'standard'
            },
            'PYG': {
                locale: 'en-US',
                currencyName: 'Guarani',
                currencyNamePlural: 'Guaranies',
                fractionalName: 'Centimo',
                fractionalNamePlural: 'Centimos',
                format: 'standard',
                noCents: true
            },
            'RWF': {
                locale: 'en-US',
                currencyName: 'Franc',
                currencyNamePlural: 'Francs',
                fractionalName: 'Centime',
                fractionalNamePlural: 'Centimes',
                format: 'standard',
                noCents: true
            },
            'WST': {
                locale: 'en-US',
                currencyName: 'Tala',
                currencyNamePlural: 'Tala',
                fractionalName: 'Sene',
                fractionalNamePlural: 'Sene',
                format: 'standard'
            },
            'STN': {
                locale: 'en-US',
                currencyName: 'Dobra',
                currencyNamePlural: 'Dobras',
                fractionalName: 'Centimo',
                fractionalNamePlural: 'Centimos',
                format: 'standard'
            },
            'RSD': {
                locale: 'en-US',
                currencyName: 'Dinar',
                currencyNamePlural: 'Dinars',
                fractionalName: 'Para',
                fractionalNamePlural: 'Para',
                format: 'standard'
            },
            'SCR': {
                locale: 'en-US',
                currencyName: 'Rupee',
                currencyNamePlural: 'Rupees',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'SLL': {
                locale: 'en-US',
                currencyName: 'Leone',
                currencyNamePlural: 'Leones',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'SBD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'SOS': {
                locale: 'en-US',
                currencyName: 'Shilling',
                currencyNamePlural: 'Shillings',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'SSP': {
                locale: 'en-US',
                currencyName: 'Pound',
                currencyNamePlural: 'Pounds',
                fractionalName: 'Piastre',
                fractionalNamePlural: 'Piastres',
                format: 'standard'
            },
            'SDG': {
                locale: 'en-US',
                currencyName: 'Pound',
                currencyNamePlural: 'Pounds',
                fractionalName: 'Piastre',
                fractionalNamePlural: 'Piastres',
                format: 'standard'
            },
            'SRD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'SZL': {
                locale: 'en-US',
                currencyName: 'Lilangeni',
                currencyNamePlural: 'Emalangeni',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'SYP': {
                locale: 'en-US',
                currencyName: 'Pound',
                currencyNamePlural: 'Pounds',
                fractionalName: 'Piastre',
                fractionalNamePlural: 'Piastres',
                format: 'standard'
            },
            'TJS': {
                locale: 'en-US',
                currencyName: 'Somoni',
                currencyNamePlural: 'Somoni',
                fractionalName: 'Diram',
                fractionalNamePlural: 'Dirams',
                format: 'standard'
            },
            'TOP': {
                locale: 'en-US',
                currencyName: 'Pa\'anga',
                currencyNamePlural: 'Pa\'anga',
                fractionalName: 'Seniti',
                fractionalNamePlural: 'Seniti',
                format: 'standard'
            },
            'TTD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'TMT': {
                locale: 'en-US',
                currencyName: 'Manat',
                currencyNamePlural: 'Manat',
                fractionalName: 'Tennesi',
                fractionalNamePlural: 'Tennesi',
                format: 'standard'
            },
            'UAH': {
                locale: 'en-US',
                currencyName: 'Hryvnia',
                currencyNamePlural: 'Hryvnias',
                fractionalName: 'Kopiyka',
                fractionalNamePlural: 'Kopiyky',
                format: 'standard'
            },
            'UZS': {
                locale: 'en-US',
                currencyName: 'Som',
                currencyNamePlural: 'Som',
                fractionalName: 'Tiyin',
                fractionalNamePlural: 'Tiyin',
                format: 'standard'
            },
            'VUV': {
                locale: 'en-US',
                currencyName: 'Vatu',
                currencyNamePlural: 'Vatu',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard',
                noCents: true
            },
            'VES': {
                locale: 'en-US',
                currencyName: 'Bolivar',
                currencyNamePlural: 'Bolivares',
                fractionalName: 'Centimo',
                fractionalNamePlural: 'Centimos',
                format: 'standard'
            },
            'YER': {
                locale: 'en-US',
                currencyName: 'Rial',
                currencyNamePlural: 'Rials',
                fractionalName: 'Fils',
                fractionalNamePlural: 'Fils',
                format: 'standard'
            },
            'ZMW': {
                locale: 'en-US',
                currencyName: 'Kwacha',
                currencyNamePlural: 'Kwacha',
                fractionalName: 'Ngwee',
                fractionalNamePlural: 'Ngwee',
                format: 'standard'
            },
            'ZWL': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'ANG': {
                locale: 'en-US',
                currencyName: 'Guilder',
                currencyNamePlural: 'Guilders',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            },
            'XCD': {
                locale: 'en-US',
                currencyName: 'Dollar',
                currencyNamePlural: 'Dollars',
                fractionalName: 'Cent',
                fractionalNamePlural: 'Cents',
                format: 'standard'
            }
        };

        // Return the config for the currency or a default
        return currencyConfigs[currencyCode] || {
            locale: 'en-US',
            currencyName: currencyCode,
            currencyNamePlural: currencyCode,
            fractionalName: 'Cent',
            fractionalNamePlural: 'Cents',
            format: 'standard'
        };
    }

    static formatAmountInWords(amount, currencyCode) {
        const config = this.getCurrencyConfig(currencyCode);

        // For currencies without cents (like JPY), round to nearest whole number
        if (config.noCents) {
            amount = Math.round(amount);
        }

        // Split amount into whole and fractional parts
        const decimalPlaces = config.decimalPlaces || 2;
        const amountStr = amount.toFixed(decimalPlaces);
        const [wholePart, fractionalPart] = amountStr.split('.');

        const wholeAmount = parseInt(wholePart);
        const fractionalAmount = parseInt(fractionalPart || '0');

        // Handle different numbering systems
        if (config.format === 'indian') {
            return this.formatIndianCurrency(wholeAmount, fractionalAmount, config);
        } else {
            return this.formatStandardCurrency(wholeAmount, fractionalAmount, config);
        }
    }

    static formatIndianCurrency(wholeAmount, fractionalAmount, config) {
        const toWords = new ToWords({
            localeCode: config.locale,
            converterOptions: {
                currency: false,
                ignoreDecimal: false,
                ignoreZeroCurrency: false,
                doNotAddOnly: true
            }
        });

        let result = '';

        if (wholeAmount > 0) {
            result = toWords.convert(wholeAmount);
            result = result.replace(/Rupees/g, config.currencyNamePlural)
                .replace(/Rupee/g, config.currencyName)
                .replace(/and\s*$/, '')
                .trim();
        }

        if (fractionalAmount > 0) {
            const fractionWords = toWords.convert(fractionalAmount);
            const fractionText = fractionWords
                .replace(/Paise/g, config.fractionalNamePlural)
                .replace(/Paisa/g, config.fractionalName)
                .replace(/and\s*$/, '')
                .trim();

            if (result) {
                result += ` and ${fractionText} ${config.fractionalNamePlural}`;
            } else {
                result = `${fractionText} ${config.fractionalNamePlural}`;
            }
        }

        // Add "Only" at the end for Indian format
        if (result) {
            result += ' Only';
        }

        return result;
    }

    static formatStandardCurrency(wholeAmount, fractionalAmount, config) {
        const toWords = new ToWords({
            localeCode: 'en-US', // Use standard English for non-Indian currencies
            converterOptions: {
                currency: false,
                ignoreDecimal: false,
                ignoreZeroCurrency: false,
                doNotAddOnly: true
            }
        });

        let result = '';

        if (wholeAmount > 0) {
            const wholeWords = toWords.convert(wholeAmount);

            // Handle singular/plural
            const currencyUnit = wholeAmount === 1 ? config.currencyName : config.currencyNamePlural;

            if (fractionalAmount === 0) {
                result = `${wholeWords} ${currencyUnit}`;
            } else {
                result = `${wholeWords} ${currencyUnit} and`;
            }
        }

        if (fractionalAmount > 0) {
            const fractionWords = toWords.convert(fractionalAmount);

            // Handle singular/plural for fractional part
            const fractionUnit = fractionalAmount === 1 ? config.fractionalName : config.fractionalNamePlural;

            if (result) {
                result += ` ${fractionWords} ${fractionUnit}`;
            } else {
                result = `${fractionWords} ${fractionUnit}`;
            }
        }

        // Add currency code for currencies without specific words
        if (result && config.currencyName === config.currencyCode) {
            result += ` (${config.currencyCode})`;
        }

        return result;
    }

    static getCurrencySymbol(currencyCode) {
        const symbols = {
            'INR': '₹',
            'USD': '$',
            'EUR': '€',
            'GBP': '£',
            'JPY': '¥',
            'CNY': '¥',
            'AUD': 'A$',
            'CAD': 'C$',
            'CHF': 'CHF',
            'SGD': 'S$',
            'NZD': 'NZ$',
            'ZAR': 'R',
            'AED': 'د.إ',
            'SAR': 'ر.س',
            'QAR': 'ر.ق',
            'KWD': 'د.ك',
            'BHD': '.د.ب',
            'OMR': 'ر.ع.',
            'EGP': 'E£',
            'IQD': 'ع.د',
            'IRR': '﷼',
            'THB': '฿',
            'MYR': 'RM',
            'IDR': 'Rp',
            'PHP': '₱',
            'VND': '₫',
            'PKR': '₨',
            'LKR': 'රු',
            'BDT': '৳',
            'RUB': '₽',
            'HKD': 'HK$',
            'TWD': 'NT$',
            'BRL': 'R$',
            'MXN': '$',
            'ARS': '$',
            'CLP': '$',
            'COP': '$',
            'SEK': 'kr',
            'NOK': 'kr',
            'DKK': 'kr',
            'PLN': 'zł',
            'ILS': '₪',
            'KES': 'KSh',
            'NGN': '₦',
            'GHS': 'GH₵',
            'JOD': 'د.ا',
            'NPR': 'रू',
            'MAD': 'د.م.',
            'DZD': 'د.ج',
            'TND': 'د.ت',
            'UGX': 'USh',
            'TZS': 'TSh',
            'PEN': 'S/',
            'UYU': '$U',
            'HUF': 'Ft',
            'CZK': 'Kč',
            'RON': 'lei',
            'KZT': '₸',
            'AFN': '؋',
            'ALL': 'Lek',
            'AOA': 'Kz',
            'AMD': '֏',
            'AWG': 'ƒ',
            'AZN': 'm',
            'BSD': 'B$',
            'BBD': 'Bds$',
            'BYN': 'Br',
            'BZD': 'BZ$',
            'BMD': '$',
            'BTN': 'Nu.',
            'BOB': 'Bs.',
            'BAM': 'KM',
            'BWP': 'P',
            'BND': 'B$',
            'BGN': 'Лв.',
            'BIF': 'FBu',
            'KHR': '៛',
            'XAF': 'FCFA',
            'XOF': 'CFA',
            'CVE': '$',
            'KYD': '$',
            'KMF': 'CF',
            'CDF': 'FC',
            'CRC': '₡',
            'CUP': '$',
            'DJF': 'Fdj',
            'DOP': '$',
            'ERN': 'Nfk',
            'ETB': 'Br',
            'FJD': 'FJ$',
            'GMD': 'D',
            'GEL': '₾',
            'GTQ': 'Q',
            'GNF': 'FG',
            'GYD': '$',
            'HTG': 'G',
            'HNL': 'L',
            'ISK': 'kr',
            'KPW': '₩',
            'KGS': 'с',
            'LAK': '₭',
            'LBP': 'ل.ل',
            'LSL': 'L',
            'LRD': '$',
            'LYD': 'ل.د',
            'MOP': 'MOP$',
            'MKD': 'ден',
            'MGA': 'Ar',
            'MWK': 'MK',
            'MVR': 'Rf',
            'MRU': 'UM',
            'MUR': '₨',
            'MDL': 'L',
            'MNT': '₮',
            'MZN': 'MT',
            'MMK': 'K',
            'NAD': '$',
            'NIO': 'C$',
            'PAB': 'B/.',
            'PGK': 'K',
            'PYG': '₲',
            'RWF': 'FRw',
            'WST': 'T',
            'STN': 'Db',
            'RSD': 'дин.',
            'SCR': '₨',
            'SLL': 'Le',
            'SBD': '$',
            'SOS': 'Sh',
            'SSP': '£',
            'SDG': 'ج.س.',
            'SRD': '$',
            'SZL': 'E',
            'SYP': '£',
            'TJS': 'ЅМ',
            'TOP': 'T$',
            'TTD': '$',
            'TMT': 'm',
            'UAH': '₴',
            'UZS': 'сўм',
            'VUV': 'VT',
            'VES': 'Bs.S.',
            'YER': '﷼',
            'ZMW': 'ZK',
            'ZWL': '$',
            'ANG': 'ƒ',
            'XCD': '$',
            'XPF': '₣'
        };

        return symbols[currencyCode] || currencyCode;
    }
}

export default CurrencyWordsFormatter;
